import TabButton from './component.jsx'
export default TabButton
